import Vue from 'vue';
import axios from 'axios';
import MaskedInput from 'vue-masked-input';

export default Vue.component('shortcuts', {
    components: {
        MaskedInput
    },
    template:`
    <fragment>
        <button class="btn btn-sm btn-dual mr-2" type="button" @click="openModal('availableShortcutsModal')">
            <i class="si si-rocket fa-fw"></i>
        </button>

        <div class="modal fade" id="availableShortcutsModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="block block-rounded block-transparent mb-0">
                        <div class="block-header bg-gray-lighter">
                            <h3 class="block-title">{{ model.title }}</h3>
                        </div>
                        <div class="block-content block-content-full">
                            <div class="row gutters-tiny">
                                <div class="col-sm-12" v-for="(shortcut, index) in model.shortcuts" :key="index">
                                    <a :class="[index < model.shortcuts.length - 1 ? 'mb-3' : 'mb-0', 'block block-themed block-rounded border']"  @click="shortcutIndex = index; openModal('shortcutModal')" style="cursor:pointer;">
                                        <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                                            <span class="font-w600 font-size-sm">
                                                {{ shortcut.title }}
                                            </span>
                                            <span>
                                                <template v-for="(key, index) in shortcut.keys">
                                                    <kbd class="bg-primary">{{ key.abbreviation }}</kbd><template v-if="index < shortcut.keys.length - 1"> + </template>
                                                </template>
                                            </span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="shortcutModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                <div class="modal-content">
                    <div class="block block-rounded block-transparent mb-0">
                        <div class="block-header bg-gray-lighter">
                            <h3 class="block-title">{{ activeShortcut.title }}</h3>
                        </div>
                        <div class="block-content block-content-full">
                            <p class="alert alert-danger" v-if="hasErrors">{{ message }}</p>

                            <div class="form-group mb-0">
                                <template v-if="activeShortcut.mask !== ''">
                                    <masked-input class="form-control" v-model="value" :disabled="loading" @input="rawValue = arguments[1]" :mask="activeShortcut.mask" :placeholder="activeShortcut.placeholder" placeholderChar=" " ref="search" type="text"/>
                                </template>
                                <template v-else>
                                    <input class="form-control" v-model="value" :disabled="loading" :placeholder="activeShortcut.placeholder" ref="search" type="text"/>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </fragment>
    `,
    data: () => ({
        activeModal: false,
        axe: axios.create({
            baseURL: '/mywecycle'
        }),
        hasErrors: false,
        keyMap: [],
        loading: false,
        message: undefined,
        model: undefined,
        rawValue: undefined,
        shortcutIndex: undefined,
        value: undefined,
    }),
    props: ["rawModel"],
    computed: {
        activeShortcut() {
            if (this.shortcutIndex) {
                return this.model.shortcuts[this.shortcutIndex];
            } else {
                return this.model.shortcuts[0];
            }
        }
    },
    watch: {
        value: function (value) {
            if (value && value.trim().length === 10) {
                this.search();
            } else {
                // Clear error message
                this.hasErrors = false;
                this.message = undefined;
            }
        }
    },
    created() {
        this.model = JSON.parse(this.rawModel);

        onkeydown = onkeyup = (e) => {
            // Stop logging keys when modal is active
            if (!this.activeModal) {
                e = e || event; // Deal with IE
                this.keyMap[e.code] = e.type == 'keydown';

                // Search for match with shortcuts
                for (const i in this.model.shortcuts) {
                    const shortcut = this.model.shortcuts[i];

                    // If shortcut has matched
                    if (this.isMatch(shortcut.keys)) {

                        // Set active shortcut index
                        this.shortcutIndex = i;

                        // Open modal
                        this.openModal('shortcutModal');

                        // Reset keyMap
                        this.keyMap = [];

                        // Prevent event to bubble up further
                        return false;
                    }
                }
            }
        }
    },
    mounted() {
        // Reset values
        window.$('#shortcutModal').on('hidden.bs.modal', () => {
            this.hasErrors = false;
            this.value = undefined;
            this.activeModal = false;
            this.shortcutIndex = undefined;
        });
        
        // Set focus on search input when modal is opened
        window.$('#shortcutModal').on('shown.bs.modal', () => {
            this.setFocus();
        });
    },
    methods: {
        isMatch(keys) {
            const keyMatches = [];

            for (const i in keys) {
                const key = keys[i];
                if (key.key === 'Control') {
                    keyMatches.push((this.keyMap['ControlLeft'] || this.keyMap['ControlRight']));
                } else if (key.key === 'Alt') {
                    keyMatches.push((this.keyMap['AltLeft'] || this.keyMap['AltRight']));
                } else {
                    keyMatches.push(this.keyMap[key.code]);
                }
            }

            return !keyMatches.includes(undefined);
        },
        openModal(modalId) {
            // Close all other open modals
            window.$('.modal').modal('hide');

            // Open modal
            window.$('#' + modalId).modal('show').appendTo('body');
            
            // Set activeModal to true to prevent further logging
            if (modalId === 'shortcutModal') {
                this.activeModal = true;
            }

            // Catch "enter" event and trigger search when focused on search input
            if (!this.$refs.search.$refs) {
                this.$refs.search.addEventListener('keyup', (e) => {
                    e = e || event; // Deal with IE
                    if (e.code === 'Enter') {
                        this.search();
                    }
                });
            }
        },
        setFocus() {
            if (this.$refs.search.$refs) {
                this.$refs.search.$refs.input.disabled = false;
                this.$refs.search.$refs.input.focus();
            } else {
                this.$refs.search.focus();
            }
        },
        search() {
            this.hasErrors = false;
            this.loading = true;
            const parameters = {};
            parameters[this.activeShortcut.parameter] = this.value;

            this.axe.post(this.activeShortcut.action, parameters)
                .then((response) => { 
                    const data = response.data;
                    if (!data.HasErrors) {
                        window.location.href = data.RedirectUrl
                    } else {
                        this.hasErrors = data.HasErrors;
                        this.message = data.Message;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.setFocus();
                });
        }
    }
});